module.exports = __webpack_public_path__ + "static/img/电子处方@2x2.771dfa41.png";